<mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'asset-shareholder-structure'">
  <mat-card-header class="detail-card-header">
    <mat-card-title data-test="title">Shareholder Structure as of
      @if (!editingDate) {
        {{reportDate | date:'mediumDate'}}
        @if (!datepickerDisabled) {
          <button mat-icon-button [disabled]="!!(isEditDisabled$ | async)" (click)="toggleEdit()" color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        }
      } @else {
        <mat-form-field class="input-date-narrow">
          <input matInput [matDatepicker]="picker" [(ngModel)]="reportDate" (dateChange)="dateChanged($event)"/>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      }
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="detail-card-content">
    @if ((shareholderStructure$ | async); as shareholderStructure) {
      <mat-card-subtitle>
        @if (shareholderStructure.status === 'ERROR') {
          <valumize-info-panel [appearance]="'ERROR'" [message]="shareholderStructure.errorMessage"></valumize-info-panel>
        }
        @if (shareholderStructure.status === 'SAVED') {
          <valumize-info-panel [appearance]="'SAVED'" [message]="'Shareholders successfully saved'"></valumize-info-panel>
        }
        @if (shareholderStructure.status === 'LOADING') {
          <mat-progress-spinner></mat-progress-spinner>
        }
        @if (calculateTotalStake() > 100) {
          <valumize-info-panel [appearance]="'ERROR'"
          [message]="'No more than 100% of the shares can be allocated in total'"></valumize-info-panel>
        }
      </mat-card-subtitle>
      @if (shareholdersForm) {
        <form [formGroup]="shareholdersForm" style="flex-direction: column">
          <div formArrayName="shareholders">
            <table mat-table [dataSource]="tableDataSource">
              <ng-container matColumnDef="shareholderName">
                <th mat-header-cell *matHeaderCellDef>Shareholder</th>
                <td mat-cell *matCellDef="let shareholder; let i = index" [formGroupName]="i">
                  @if ((shareholderStructureIsEditable$ | async) && shareholder.get('source').value === 'MANUAL' ) {
                    <input matInput formControlName="shareholderName"
                      >
                  }
                  @if ((shareholderStructureIsEditable$ | async) === false || shareholder.get('source').value !== 'MANUAL') {
                    <span [style.font-weight]="shareholder.get('source').value !== 'MANUAL' ? 'bold' : 'none'">
                      {{shareholder.get('shareholderName').value}}
                    </span>
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef> Adjustment</td>
              </ng-container>
              <ng-container matColumnDef="stake">
                <th mat-header-cell *matHeaderCellDef> Stake</th>
                <td mat-cell *matCellDef="let shareholder; let i = index" [formGroupName]="i">
                  @if ((shareholderStructureIsEditable$ | async) && shareholder.get('source').value === 'MANUAL' ) {
                    <input matInput class="input-number-narrow" formControlName="stake">
                  }
                  @if ((shareholderStructureIsEditable$ | async) === false || shareholder.get('source').value !== 'MANUAL') {
                    {{shareholder.get('stake').value}}%
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef>{{getStakeGap() | number:'1.0-2'}}%</td>
              </ng-container>
              <ng-container matColumnDef="progressBar">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let shareholder">
                  <mat-progress-bar mode="determinate" [value]="shareholder.get('stake').value " style="min-width: 100px"></mat-progress-bar>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let shareholder; let i = index">
                  @if ((shareholderStructureIsEditable$ | async)  && shareholder.get('source').value === 'MANUAL' ) {
                    <button mat-icon-button color="primary"
                      (click)="removeShareholder(i)">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  }
                  @if ((shareholderStructureIsEditable$ | async) && shareholder.get('source').value === 'GENERATED') {
                    <button mat-icon-button matTooltip="To edit this shareholder, please use the &quot;Manage investments&quot; dialog on the fund page" matTooltipPosition="above" style="color: #FF8C00;">
                      <mat-icon>info_outline</mat-icon>
                    </button>
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index" [formGroupName]="i"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns" [class.hidden-footer]="getStakeGap() === 0"></tr>
            </table>
          </div>
        </form>
      }
      @if ((shareholderStructureIsEditable$ | async)) {
        <button mat-raised-button color="primary" type="button" (click)="addShareholder()">Add Shareholder</button>
      }
    }

    <mat-expansion-panel class="mat-expansion-panel">
      <mat-expansion-panel-header class="mat-expansion-panel-header">
        All shareholders
      </mat-expansion-panel-header>
      @if ((shareholderStructureIsEditable$ | async)) {
        <mat-card-subtitle>
          Click + to copy a shareholder over to the current selected date
        </mat-card-subtitle>
      }
      @if (allShareholders$ | async; as allShareholders) {
        <table mat-table [dataSource]="allShareholders">
          <ng-container matColumnDef="shareholderName">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element" style="height: 48px;">{{element.shareholderName | traceableFormat}}</td>
          </ng-container>
          <ng-container matColumnDef="stake">
            <th mat-header-cell *matHeaderCellDef>Stake</th>
            <td mat-cell *matCellDef="let element" style="height: 48px;">{{element.stake | traceableFormat}}</td>
          </ng-container>
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let element" style="height: 48px;">{{element.date | traceableFormat}}</td>
          </ng-container>
          <ng-container matColumnDef="add">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" style="height: 48px; padding: 0">
              @if ((shareholderStructureIsEditable$ | async)) {
                <button mat-icon-button color="primary" (click)="copyShareholderToCurrentDate(element)">
                  <mat-icon>add</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['shareholderName', 'stake', 'date', 'add']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['shareholderName', 'stake', 'date','add'];"></tr>
        </table>
      }
    </mat-expansion-panel>
  </mat-card-content>

  <mat-card-actions class="detail-card-actions">
    @if ((shareholderStructureIsEditable$ | async) === false) {
      <button mat-icon-button
        color="primary"
        data-test="edit-button"
        (click)="editMode()"
        [disabled]="!!(isEditDisabled$ | async)">
        <mat-icon>edit</mat-icon>
      </button>
    }
    @if ((shareholderStructureIsEditable$ | async)) {
      <button mat-icon-button color="primary" data-test="save-button" (click)="save()" [disabled]="calculateTotalStake() > 100">
        <mat-icon>save</mat-icon>
      </button>
    }
    @if ((shareholderStructureIsEditable$ | async)) {
      <button mat-icon-button color="primary" data-test="cancel-button" (click)="cancel()">
        <mat-icon>cancel</mat-icon>
      </button>
    }
    <valumize-card-comments-button [commentSlug]="'asset-shareholder-structure'"></valumize-card-comments-button>
  </mat-card-actions>
</mat-card>
